import { AnimatePresence, motion } from 'framer-motion';
import React, { FC } from 'react';

import HorizontalScroll from '@/components/Layout/Header/Search/Suggestions/HorizontalScroll';
import Orange from '@/components/Layout/Header/Search/Suggestions/Orange';

import { Book as IBook } from '@/utils/interfaces/Library/Books';

interface Props {
  oranges?: IBook[];
  onClickBook?: () => void;
}

const OrangeCarousel: FC<Props> = ({ oranges = [], onClickBook }) => {
  return (
    <HorizontalScroll scrollAmount={250} className='sm:gap-3 gap-2'>
      <AnimatePresence mode='popLayout'>
        {oranges?.map((book, index) => (
          <motion.div
            key={book._id}
            layout
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.25 }}
          >
            <Orange onClickBook={onClickBook} book={book} key={index} />
          </motion.div>
        ))}
      </AnimatePresence>
    </HorizontalScroll>
  );
};

export default OrangeCarousel;
